module.exports = __webpack_public_path__ + "static/media/step-3.4ba16b43.png";